<template>
<v-container>
  <h2 class="title"><v-icon class="mr-3">mdi-check</v-icon>Mes validations</h2>
  <v-list v-if="validations.length > 0">
    <template v-for="(v,i) in sorted">
      <v-list-item two-line :key="i" @click="openPoint(v.point)">
        <v-list-item-content>
        <v-list-item-title>{{ v.name }}</v-list-item-title>
        <v-list-item-subtitle>{{ v.value }} point(s) - {{ new Date(v.created).toLocaleDateString() }} {{ new Date(v.created).toLocaleTimeString() }}</v-list-item-subtitle>
      </v-list-item-content>

      </v-list-item>
      <v-divider :key="'div_'+i"/>
    </template>
  </v-list>
</v-container>

</template>
<script>

export default {
  data () {
    return {
      validations: []
    }
  },
  computed: {
    sorted: function() {

      return this.validations.slice().sort((a,b) => { return b.created > a.created; });
    }
  },
  methods: {
    openPoint(id) {
      this.$store.dispatch('openDialog', {id: id});
    }
  },
  mounted() {
    if (this.$store.getters.user.data) {
      this.validations =  this.$store.getters.user.data.validations;
    }
  }
}
</script>
